import './box.sass';

export { default } from './box';
